import styled from "styled-components";
import checkMark from "../assets/icons/check-mark.svg";

const ContactStyles = styled.div`
  width: 1040px;
  margin: 0 auto;
  min-height: 500px;
  line-height: normal;

  textarea,
  input.text,
  input[type="text"],
  input[type="button"],
  input[type="submit"],
  .input-checkbox {
    -webkit-appearance: none;
  }

  .contact-confirmation {
    font-size: 18px;
    line-height: 26px;
  }

  .suggest {
    &__check {
      &-label {
        position: relative;
        line-height: normal;
        padding-left: 34px;
        display: inline-block;

        &:before {
          position: absolute;
          left: 0;
          content: "";
          margin-right: 10px;
          display: inline-block;
          vertical-align: text-top;
          width: 22px;
          height: 22px;
          border: 1px solid #afafaf;
          border-radius: 2px;
        }
      }

      &-item {
        width: 370px;
        margin-bottom: 20px;
        position: relative;
        margin-right: 30px;
      }
    }

    &__checkboxes {
      width: 730px;
      height: 188px;
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      justify-content: flex-start;
      margin-bottom: 40px;
    }

    &__body-text {
      width: 730px;
      margin: 0 auto;
    }

    &__subheader {
      font-family: var(--header-font-bold);
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      margin-bottom: 40px;
    }

    &__confirmation {
      font-size: 16px !important;
      line-height: 24px;
      width: 500px;
      margin: 80px auto;
    }
  }

  span.multi-line {
    font-size: 16px !important;
    text-align: left !important;
  }

  .__react_component_tooltip.show {
    opacity: 1 !important;
  }

  .suggest-check {
    opacity: 0;
    width: 0;
  }

  .suggest-check:checked + label:before {
    background: white;
  }

  .suggest-check:checked + label:after {
    position: absolute;
    left: 3px !important;
    top: -2px;
    content: url(${checkMark});
    z-index: 10000;
  }

  .form {
    margin: 0 auto;
    width: 730px;

    &__char-count {
      font-size: 14px;
      color: #757575;
      line-height: 1.2;
      text-align: right;
      width: 730px;
    }

    &__input {
      font-family: var(--body-font);
      font-size: 18px;
      line-height: normal;
      display: block;
      outline: none;
      border: none;
      border-bottom: 1px var(--off-black) solid;
      border-radius: 0;
      background: none;
      padding-bottom: 4px;
      margin: 0 auto;
      position: relative;

      &-container {
        position: relative;
        display: inline-block;

        &--hp {
          position: absolute;
          top: 0;
          opacity: 0;
          z-index: -10;
        }
      }

      &-container--long {
        position: relative;
      }
    }

    &__input--full-width {
      width: 730px;
    }

    &__input--half-width {
      width: 350px;
    }

    &__text-area {
      font-family: var(--body-font);
      font-size: 18px;
      line-height: 22px;
      display: block;
      width: 730px;
      height: 200px;
      padding: 6px;
      border: 1px var(--off-black) solid;
      margin: 0 auto;
      margin-bottom: 8px;
      margin-top: 80px;
      resize: none;
      border-radius: 0;

      &:focus,
      &:active {
        outline: none;
      }
    }

    &__label,
    &__comment-label {
      display: block;
      font-size: 16px;
      line-height: 24px;
      padding-top: 4px;
      margin: 0 auto;
    }

    &__label {
      margin-bottom: 20px;

      &--with-tooltip {
        &:after {
          content: "?";
          background: var(--off-black);
          color: white;
          display: inline-block;
          width: 22px;
          height: 22px;
          text-align: center;
          border-radius: 100px;
          position: absolute;
          right: 0;
        }
      }
    }

    &__comment-label {
      margin-top: 36px;
      padding-bottom: 4px;
    }

    &__button {
      display: block;
      background: var(--off-black);
      max-width: 300px;
      height: 48px !important;
      border: none;
      box-shadow: none;
      font-size: 16px;
      color: white;
      letter-spacing: 1.11px;
      text-align: center;
      text-transform: uppercase;
      margin: 0 auto;
      margin-top: 40px;
      margin-bottom: 50px;
      cursor: pointer;
      border-radius: 100px;
      outline: none;
      padding: 0 60px;
    }
  }

  @media only screen and (max-width: 1050px) {
    width: 730px;
  }

  @media only screen and (max-width: 800px) {
    width: 100%;
    max-width: 500px;
    .suggest {
      &__body-text {
        max-width: 500px;
        width: 100%;
        margin: 0 auto;
        padding: 0 20px;
        text-align: center;
      }

      &__subheader {
        max-width: 500px;
        width: 100%;
        margin: 0 auto;
        margin-bottom: 40px;
        line-height: 32px;
      }

      &__confirmation {
        max-width: 500px;
        width: 100%;
      }

      &__checkboxes {
        width: 100%;
        max-width: 500px;
        flex-direction: column;
        height: auto;
        flex-wrap: nowrap;
      }

      &__check {
        &-item {
          width: 100%;
          max-width: 500px;
          margin-right: 0;
        }
      }
    }

    .form {
      max-width: 500px;
      width: 100%;
      padding: 0 12px;

      &__char-count {
        max-width: 500px;
        width: 100%;
      }

      &__input--full-width,
      &__input--half-width {
        width: 100%;
        max-width: 500px;
      }

      &__input-container {
        width: 100%;
        max-width: 500px;
        margin-right: 0 !important;

        &--hp {
          position: absolute;
          top: 0;
          opacity: 0;
          z-index: -10;
        }
      }

      &__text-area {
        width: 100%;
        max-width: 500px;
      }
    }
  }

  @media only screen and (max-width: 768px) and (pointer: coarse) {
    padding: 0;
    width: 100%;

    .suggest {
      &__confirmation {
        font-size: 14px !important;
        line-height: 22px;
        width: 280px;
        margin: 80px auto;
      }
    }
  }
`;

export default ContactStyles;
